import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import LookCard from "@/components/LookCard";
import ComingSoonTile from "@/components/ComingSoonTile";

export default function Looks() {
  const { mood } = useParams();
  const [sp] = useSearchParams();
  const [looks, setLooks] = useState([]);

  useEffect(() => {
    const params = {};
    if (mood) params.mood = mood;
    if (window.location.pathname.includes("new-in")) params.new = true;
    api.get("/looks", { params }).then(({ data }) => setLooks(data));
  }, [mood, sp]);

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24">
      <div className="mb-14">
        <div className="text-[11px] tracking-editorial uppercase text-[#C3B1C5] mb-3">◈ Shop The Looks</div>
        <h1 className="font-serif-display text-[42px] md:text-[64px] tracking-tight leading-none uppercase">
          {mood ? mood : "The Latest Looks"}
        </h1>
        <p className="mt-3 text-[14px] italic text-[#4A464A]/70">every look, already paired</p>
      </div>
      <div data-testid="looks-grid" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-14">
        {looks.map((l, i) => <LookCard key={l.id} look={l} index={i} />)}
        {looks.length > 0 && <ComingSoonTile nextNumber={String(looks.length + 1).padStart(2, "0")} />}
        {looks.length === 0 && <div className="col-span-full text-center text-[13px] text-[#4A464A]/60 py-24">No looks yet in this mood — check back soon ♡</div>}
      </div>
    </div>
  );
}
